import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

import AccordionToggle from './AccordionToggle';

export default class AccordionHeader extends PureComponent {
  static propTypes = {
    children: PropTypes.object,
    className: PropTypes.string
  };

  render() {
    const { children, className, ...props } = this.props;

    return (
      <div className={`accordion__header ${className}`}>
        {children}

        <AccordionToggle {...props} />
      </div>
    );
  }
}
